import styled from "styled-components";
import ButtonCSS from "../../Common/Buttons/Button.css";

const StyledForm = styled.form`

  label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }

  .contact_form-label {
    font-size: 1.25rem;
    line-height: 1;
  }

  .contact_field {
    background-color: #fff;
    font-size: 1.25rem;
    line-height: 1;
  }

  .w-input {
    display: block;
    width: 100%;
    height: 38px;
    padding: 8px 12px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333333;
    vertical-align: middle;
    background-color: #ffffff;
    border: 1px solid #cccccc;
  }

  /****************************/
  /* Contact Me Submit Button */
  /****************************/

  ${ButtonCSS}

  .form_validation_error {
    color: red;
  }

  .mb-3 {
    margin-bottom: 1rem;
  }
  
  /****************************/
  /*     Form Messages        */
  /****************************/

  .w-form-done {
   // display: none;
    padding: 20px;
    text-align: center;
    background-color: #dddddd;
  }

  .form_success-text {
    font-size: 1.25rem;
    line-height: 1;
  }

  .w-form-fail {
    display: none;
    margin-top: 10px;
    padding: 10px;
    background-color: #ffdede;
  }

  .form_error-text {
    font-size: 1.25rem;
    line-height: 1;
  }

`;

export default StyledForm;

